import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import { clientConfigRoleLabels } from "./ClientConfiguration/i18n";

function DeletedTemplatePrompt() {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const { locals } = useRillContext();
  const { athlete, clientConfigurationTemplates = [], activeUserToRequest } =
    locals;
  const roleLabels = clientConfigRoleLabels(
    t,
    Boolean(activeUserToRequest?.referAsClients)
  );

  const [mode, setMode] = useState("prompt");
  const [selectedTemplateId, setSelectedTemplateId] = useState("");

  if (mode === "reassign") {
    return (
      <form
        action={`/client-configuration/reassign-template?athlete=${athlete._id}`}
        method="POST"
      >
        <input type="hidden" name="templateId" value={selectedTemplateId} />
        <Modal
          title={t("clientConfiguration.deletedTemplate.reassignTitle")}
          goBack={() => setMode("prompt")}
          backButton
        >
          <div className="body">
            <p>
              {t(
                "clientConfiguration.deletedTemplate.reassignDescription",
                roleLabels
              )}
            </p>
            <select
              value={selectedTemplateId}
              onChange={(e) => setSelectedTemplateId(e.target.value)}
              required
            >
              <option value="" disabled>
                {t("clientConfiguration.deletedTemplate.selectPlaceholder")}
              </option>
              {clientConfigurationTemplates.map((template) => (
                <option key={template._id} value={template._id}>
                  {template.templateName}
                </option>
              ))}
            </select>
          </div>
          <footer>
            <button
              type="button"
              data-button-type="secondary"
              data-action="cancel"
              onClick={() => setMode("prompt")}
            >
              {t("clientConfiguration.deletedTemplate.back")}
            </button>
            <button
              data-button-type="primary"
              type="submit"
              disabled={!selectedTemplateId}
            >
              {t("clientConfiguration.deletedTemplate.reassign")}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }

  return (
    <Modal title={t("clientConfiguration.deletedTemplate.title")} canClose>
      <div className="body">
        <p>{t("clientConfiguration.deletedTemplate.description", roleLabels)}</p>
      </div>
      <footer>
        <form
          action={`/client-configuration/detach?athlete=${athlete._id}`}
          method="POST"
          style={{ display: "inline" }}
        >
          <button data-button-type="secondary" type="submit">
            {t("clientConfiguration.deletedTemplate.detach")}
          </button>
        </form>
        <button
          data-button-type="primary"
          type="button"
          onClick={() => setMode("reassign")}
        >
          {t("clientConfiguration.deletedTemplate.reassign")}
        </button>
      </footer>
    </Modal>
  );
}

export default DeletedTemplatePrompt;
